import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../../common/AutoBindComponent";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";

import * as layoutActions from "../../../actions/layoutActions";
import * as beads from "../../../actions/beadActions";

import KostOpbrengstEditForm from "./KostOpbrengstEditForm";
import KostOpbrengstEditPageHelper from "./KostOpbrengstEditPageHelper";
import * as types from "../../../constants/ComponentConstants";

class KostOpbrengstEditPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            model: {},
            validationMessages: {}
        };

        this.pageHelper = new KostOpbrengstEditPageHelper(this);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnSave() {
        this.pageHelper.save();
    }

    handleOnClose() {
        this.pageHelper.goToOverview();
    }

    handleOnChange(event, data) {
        this.pageHelper.change(event, data);
    }

    handleOnKopieBedragNaarAndereJaren()
    {
        this.pageHelper.kopieBedragNaarAndereJaren();
    }

    render() {
        return (<KostOpbrengstEditForm
            model={this.state.model}
            errors={this.state.validationMessages}
            validationMessages={this.state.validationMessages}
            color={types.COLOR_PINK_LIGHT}
            okiTypes={this.props.okiTypes}
            onBewaarClick={this.handleOnSave}
            onSluitClick={this.handleOnClose}
            onChange={this.handleOnChange}
            disabled={this.state.model.dossierIngediend}
            type={this.props.type}
            okPosten={this.props.okPosten}
            isNew={!this.state.kostOpbrengstId}
            onKopieBedragNaarAndereJaren={this.handleOnKopieBedragNaarAndereJaren}
        />);
    }
}

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;
    const type = ownProps.route.params.type;

    return {
        dossierId: dossierId,
        okiTypes: state.referentie.typeOpbrengstKostInvesteringen,
        okiTypesForDropdown: state.referentie.typeOpbrengstKostInvesteringen.map(item => { return { label: item.titel, value: item.id }; }),
        type: type,
        okPosten: state.referentie.opbrengstKostPosten
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadKostOpbrengstEditPageLayout, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(KostOpbrengstEditPage));